//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { add, cloneDeep } from '~/assets/js/utils.js'
export default {
  data () {
    return {
      searchCountry: '', // 搜索绑定
      seleLetter: 'A', // 选中的字母
      searchData: [], // 搜索出来的数据
      scrollY: 0, // 获取实时滚动位置
      heightList: [] // 获取每一个li的高度
    }
  },
  computed: {
    // 英文字母当前选中项
    currentIndex () {
      const value = this.heightList?.findIndex((item, index) => this.scrollY >= this.heightList[index] && this.scrollY < this.heightList[index + 1])
      return value > 0 ? value : 0
    },
    // 国家字母分类
    goodMenletter () {
      return !this.isChinese() ? ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'Y', 'Z'] : ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'W', 'X', 'Y', 'Z']
    },
    // 所有国家列表（包含字母分类）
    countries () {
      return !this.isChinese() ? require('~/static/json/areaCodeEN.json') : require('~/static/json/areaCodeCN.json')
    }
  },
  watch: {
    // 搜索后的列表
    searchCountry (newV) {
      if (!newV) return false
      const patt = new RegExp(newV, 'i')
      if (!this.coulist) {
        const newArr = []
        this.countries?.forEach((item) => {
          item.data?.forEach((e) => {
            newArr.push(e)
          })
        })
        this.coulist = cloneDeep(newArr)
      }
      this.searchData = this.coulist?.filter(i => (patt.test(i.name) || i.code.search(newV) != -1)) || []
    }
  },
  methods: {
    // 国家滚动
    cyScroll () {
      this.scrollY = this.$refs?.goodList?.scrollTop || this.$refs?.goodList?.scrollTop || 0
    },
    // 计算每一个英文首字母的列表高度
    getHeight () {
      const lis = this.$refs?.rItem // 获取每一个li的高度
      let height = 0
      this.heightList.push(height)
      lis?.forEach((item) => { // 之后的高度即为当前li的高度加上之前面li的高度和
        height = add(height, item.clientHeight)
        this.heightList.push(height)
      })
    },
    // 字母点击滚动
    selectLeft (index = 0) {
      const rItem = this.$refs?.rItem
      const el = rItem[index]
      this.seleLetter = el?.getAttribute('data-num')
      const goodind = this.goodMenletter?.findIndex((item, ind) => item == this.seleLetter ? ind : '')
      this.$nextTick(() => {
        this.$refs.goodList.scrollTop = this.heightList[goodind]
      })
    }
  }
}
